import type { RouteObject } from 'react-router-dom';
import CohortsPage from '@pages/CohortsPage/CohortsPage';
import CohortCreatePage from '@pages/CohortsPage/CohortCreatePage';
import CohortDetailsPage from '@pages/CohortsPage/CohortDetailsPage';

const cohortRoutes: RouteObject[] = [
    {
        path: '/admin/cohorts',
        element: <CohortsPage />,
    },
    {
        path: '/admin/cohorts/create',
        element: <CohortCreatePage />,
    },
    {
        path: '/admin/cohorts/:id',
        element: <CohortDetailsPage />,
    },
];

export default cohortRoutes;
